import { Flex, Heading, TabPanel, Tabs, TabPanels } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UserContentLayout } from '../../components/Layouts/UserContentLayout';
import { InviteSuccessSended } from '../../components/User/Member/TransitonToUserTabs/InviteSuccessSended';
import { SendInvitation } from '../../components/User/Member/TransitonToUserTabs/SendInvitation';

const MemberTransitionToUser = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);

  const goBack = () => navigate(-1);
  const toSuccessTab = () => setTabIndex(1);

  return (
    <UserContentLayout caption={`${t('members.page.caption')}`}>
      <Flex maxW='xl' flexDirection='column'>
        <Heading fontSize='22px' my='5vh'>
          {t('member.invite.sub.caption')}
        </Heading>

        <Tabs index={tabIndex}>
          <TabPanels>
            <TabPanel p={0}>
              <SendInvitation goBack={goBack} isCompleted={toSuccessTab} />
            </TabPanel>

            <TabPanel p={0}>
              <InviteSuccessSended goBack={goBack} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Flex>
    </UserContentLayout>
  );
};

export default MemberTransitionToUser;
